import React, {useEffect} from 'react';
import Nav from './components/nav';
import {BrowserRouter, Route, Switch, useLocation} from 'react-router-dom';
import _routes from "./routers/router";
import { Provider } from 'react-redux'
import { createStore } from "redux";
import reducer from './store/reducer/index'
import {useModal} from "./components/modal";
import * as Sentry from "@sentry/react";



const setFontSize = () => {
    const html = document.querySelector('html')
    if (window.innerWidth >= 750 && html) {
        html.style.fontSize = '70px'
    } else if (window.innerWidth < 750 && html) {
        html.style.fontSize = Math.ceil(window.innerWidth / 7.5) + 'px';
    }
}

const store =  createStore(reducer)

function ForEachRouter(){
    const l = useLocation().pathname
    const modal = useModal()

    useEffect(() => {
        modal.hide()
    },[l])

    return null
}

function App() {

    useEffect(() => {
        setFontSize()
        window.addEventListener('resize', setFontSize, false)

        return () => {
            window.removeEventListener('resize', setFontSize, false)
        }
    }, [])

    return (
        <div className="App">
            <div className="app-body">
                <Provider store={ store }>
                <BrowserRouter >
                    <ForEachRouter/>
                    <Switch>
                        {
                            _routes.map((item, index) => {
                                const {component: Component, path} = item
                                return <Route
                                    key={index}
                                    path={path}
                                    exact
                                    render={(routeProps) => <Component {...routeProps}/>}/>
                            })
                        }
                    </Switch>
                    <Nav/>
                </BrowserRouter>
                </Provider>
            </div>
        </div>
    );
}

export default Sentry.withProfiler(App);
